import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authSlice } from "@unlikelyai-magic/shared/data-access/api";
import { orchestrationApi } from "./orchestrationApi";
import { processedClausesSlice } from "./product-rec/decisionProcessesSlice";
import { activePaneIdSlice } from "./product-rec/decisionProcessesSlice";
import { evaluationExamplesSlice } from "./product-rec/evaluationExamplesSlice";
import { highlightsSlice } from "./product-rec/highlightsSlice";
import { ingestionApi } from "./product-rec/ingestionApi";
import { productRecommendationApi } from "./product-rec/productRecommendationApi";
import { regulationQuerySlice } from "./product-rec/regulationQuerySlice";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    [orchestrationApi.reducerPath]: orchestrationApi.reducer,
    [productRecommendationApi.reducerPath]: productRecommendationApi.reducer,
    [ingestionApi.reducerPath]: ingestionApi.reducer,
    regulationQuery: regulationQuerySlice.reducer,
    highlights: highlightsSlice.reducer,
    processedClauses: processedClausesSlice.reducer,
    activePaneId: activePaneIdSlice.reducer,
    evaluationExamples: evaluationExamplesSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(orchestrationApi.middleware)
      .concat(productRecommendationApi.middleware)
      .concat(ingestionApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
